<template>
  <div class="modal-content p-3">
    <div class="row align-items-center mb-3"></div>
    <div class="row align-items-center mb-3">
      <div class="col-6" v-if="formModel?.request_category?.display.includes('archive')">
        <label class="form-label mb-0">Архивная папка</label>
        <ArcFolder v-model="formModel.archive" />
      </div>
    </div>
    <div class="d-flex justify-content-start gap-2 mt-3">
      <button type="button" class="btn btn-success" @click="confirm">Завершить обращение</button>
      <button type="button" class="btn btn-outline-danger" @click="cancel">Отменить</button>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, watch } from 'vue'
import cloneDeep from 'lodash-es/cloneDeep'
import DatePicker from '@provise/components/datepicker.vue'
import ArcFolder from '@/components/simpleSchema/fields/archive_folder.vue'

const props = defineProps({
  model: Object,
})

const emit = defineEmits(['modalstack:close'])

const model = toRef(props, 'model')
const formModel = ref({})

watch(
  model,
  newVal => {
    formModel.value = cloneDeep(newVal)
  },
  { immediate: true, deep: true }
)

const confirm = () => {
  Object.assign(model.value, formModel.value)
  emit('modalstack:close', { completed: true })
}

const cancel = () => {
  emit('modalstack:close', false)
}
</script>
